export const advantagesData = [
  {
    title: 'Документация<br> для 11 000<br> моделей техники',
  },
  {
    title: 'Актуальная информация<br> и техническая поддержка',
  },
  {
    title: 'База данныx на более<br> 10 000 000 деталей',
  },
  {
    title:
      'Поддержка<br>брендов Groupe SEB:<br><br>Tefal, Rowenta, Krups, Moulinex, WMF',
  },
];
